module.exports = __webpack_public_path__ + "static/media/house_success_right.06b6b677.png";